module.exports = __webpack_public_path__ + "static/imac-fc3f22bd3d754ce4eb3dc59c4e188e7d.png";